import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
import BottomSheet from './BottomSheet';
import BottomSheetButtonGroup, { BottomSheetButtonGroupLayout, } from './BottomSheet/BottomSheetButtonGroup';
const ContentsContainer = styled.View({
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 28,
    paddingHorizontal: 20,
});
const Title = styled.Text({
    width: '100%',
    color: color.black,
    fontSize: 20,
    fontFamily: font.pretendardBold,
    marginTop: 10,
    marginBottom: 10,
});
const Message = styled.Text({
    width: '100%',
    color: color.black,
    fontSize: 16,
    fontFamily: font.pretendardRegular,
});
const AppUpgradeNeededBottomSheet = ({ isVisible, isRequired, message, onConfirmButtonPressed, onCloseButtonPressed, }) => {
    return (_jsxs(BottomSheet, { isVisible: isVisible, children: [_jsxs(ContentsContainer, { children: [_jsx(Title, { children: isRequired
                            ? '최신 버전으로 업데이트가 필요해요'
                            : '최신 버전으로 업데이트를 권장해요' }), _jsx(Message, { children: message })] }), isRequired ? (_jsx(BottomSheetButtonGroup, { layout: BottomSheetButtonGroupLayout.VERTICAL, positiveButton: {
                    text: '업데이트 하기',
                    onPressed: () => {
                        onConfirmButtonPressed();
                    },
                } })) : (_jsx(BottomSheetButtonGroup, { layout: BottomSheetButtonGroupLayout.HORIZONTAL_1X2, positiveButton: {
                    text: '업데이트 하기',
                    onPressed: () => {
                        onConfirmButtonPressed();
                    },
                }, negativeButton: {
                    text: '닫기',
                    onPressed: () => {
                        onCloseButtonPressed();
                    },
                } }))] }));
};
export default AppUpgradeNeededBottomSheet;
